/**
 * The text of a comment on its way from the reader to the edit tree: hex of its UTF-8 bytes. No later
 * pass of the reader and no tag attribute can mistake hex for markup, whatever the comment holds.
 */
export const encodeCommentText = (text: string): string =>
	Array.from(new TextEncoder().encode(text), (byte) => byte.toString(16).padStart(2, "0")).join("");

export const decodeCommentText = (hex: string): string =>
	new TextDecoder().decode(Uint8Array.from(hex.match(/../g) ?? [], (pair) => Number.parseInt(pair, 16)));

export const commentMarkup = (text: string) => `<!--${text}-->`;
